<div class="container-center">
    <div class="row">
        <div class="col-12 text-center">
            <a (click)="informParent()" class="link-secondary text-center">Loading payment methods...</a>
        </div>
    </div>
</div>
